import { useIntl } from "react-intl";

const useDirection = () => {
  const { locale } = useIntl();
  const isRTL = ["ar", "he", "fa"].includes(locale);
  return isRTL ? "rtl" : "ltr";
};

export default useDirection;
